// Toaster.js
import React, { useEffect, useRef, useState } from "react";
import { Toast } from "bootstrap";

let showGlobalToast = null; // 👈 external trigger function

export const showToast = (message, type = "success") => {
  if (showGlobalToast) {
    showGlobalToast(message, type);
  }
};

function Toaster() {
  const toastRef = useRef(null);
  const [message, setMessage] = useState("");
  const [type, setType] = useState("success");

  useEffect(() => {
    showGlobalToast = (msg, toastType) => {
      setMessage(msg);
      setType(toastType);

      const toast = new Toast(toastRef.current, {
        delay: 3000,
      });

      toast.show();
    };
  }, []);

  return (
    <div className="toast-container position-fixed top-0 end-0 p-3">
      <div
        ref={toastRef}
        className={`toast align-items-center text-bg-${type} border-0`}
        role="alert"
      >
        <div className="d-flex">
          <div className="toast-body">{message}</div>
          <button
            type="button"
            className="btn-close btn-close-white me-2 m-auto"
            data-bs-dismiss="toast"
          ></button>
        </div>
      </div>
    </div>
  );
}

export default Toaster;
